const LAT = 51.20127;
const LON = 51.373158;
const WEATHER_API_KEY = "fe41210fc3cf8c055955c7a16f99997a";
const LANG = "ru";
const UNITS = "metric";

export const fetchWeatherData = async () => {
  try {
    const response = await fetch(
      `https://api.openweathermap.org/data/3.0/onecall?lat=${LAT}&lon=${LON}&appid=${WEATHER_API_KEY}&lang=${LANG}&units=${UNITS}`,
    );

    if (!response.ok) {
      throw new Error("Ошибка получения данных о погоде");
    }

    return await response.json();
  } catch (error) {
    console.error("Ошибка при получении погоды:", error);
    throw error;
  }
};
